import { exec } from "child_process";

import { ExecOptions, ExecOutputReturnValue } from "shelljs";

import { ILogger } from "./Logging/ILogger";

type Omit<T, K extends keyof T> = Pick<
    T,
    ({ [P in keyof T]: P } & { [P in K]: never } & { [x: string]: never })[keyof T]
>;

interface ExecCommandAsyncOptions extends Omit<ExecOptions, "async" | "silent"> {
    caption?: string;
}

export function execCommandAsync(
    logger: ILogger,
    command: string,
    options: ExecCommandAsyncOptions = {}
): Promise<ExecOutputReturnValue> {
    return new Promise<ExecOutputReturnValue>((resolve, reject) => {
        const { caption, ...execOptions } = options;
        if (caption != undefined) {
            logger.log(caption);
        }
        logger.verbose(`Run: ${command}`);
        exec(command, { ...execOptions }, (error, stdout, stderr) => {
            for (const line of stdout.split("\n")) {
                logger.verbose(line);
            }

            for (const line of stderr.split("\n")) {
                logger.verbose(line);
            }

            if (error !== null) {
                // eslint-disable-next-line @typescript-eslint/no-base-to-string
                reject(new Error(`Executed with exit code ${error}`));
            }
            resolve({
                code: 0,
                stdout: stdout,
                stderr: stderr,
            });
        });
    });
}
